function Home() {
  return (
    <div className="Home">
      Aplicativo do TibiaRPGBrasil
    </div>
  );
}

export default Home;
